export default "__VITE_ASSET__C3$5sFdZ__"